
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { apiShopMoneyData, apiShopLists } from "@/api/shop";
import SearchBtns from "@/components/search-btns.vue";
import { RequestPaging } from "@/utils/util";
import DatePicker from "@/components/date-picker.vue";
import LsPagination from "@/components/ls-pagination.vue";
import elImageViewer from "element-ui/packages/image/src/image-viewer.vue";
import ExportData from "@/components/export-data/index.vue";

@Component({
  components: {
    LsPagination,
    DatePicker,
    elImageViewer,
    SearchBtns,
    ExportData,
  },
})
export default class ShopMoneyList extends Vue {
  // 界面表格数据
  pager: any = new RequestPaging();

  apiShopMoneyData = apiShopMoneyData;
  searchObj: any = {
    sid: "",
    date: "",
  };
  money_type_list: any[] = [];
  type_list: any[] = [];
  loading = false;
  shopList: any[] = [];

  handleSearch() {
    this.pager.page = 1;
    this.getList();
  }
  getList() {
    this.loading = true; // 开始加载状态
    this.pager
      .request({
        callback: this.apiShopMoneyData,
        params: this.searchObj, // 传递搜索参数
      })
      .then((res: any) => {
        this.loading = false; // 请求完成，停止加载状态
      })
      .catch((error: any) => {
        console.error("获取订单列表失败:", error);
      });
  }

  async getShopList() {
    try {
      let res = await apiShopLists({ page_size: 9999 });
      this.shopList = res.lists;
    } catch (error) {}
  }
  async mounted() {
    this.searchObj.date = new Date().toLocaleDateString().split("/").join("-");
    await this.getShopList();
    this.getList();
  }
}
